import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ScrollPanel } from 'primeng/scrollpanel';

@Component( {
  selector: 'app-barra-lateral-contenido',
  templateUrl: 'barra-lateral-contenido.component.html'
} )

export class BarraLateralContenidoComponent implements AfterViewInit {

  @ViewChild('scroller', { static: true }) layoutMenuScrollerViewChild: ScrollPanel;

  constructor() {
  }

  ngAfterViewInit() {
    setTimeout( () => {
      this.layoutMenuScrollerViewChild.moveBar();
    }, 100 );
  }

  onClick( event: Event ) {
    setTimeout( () => {
      this.layoutMenuScrollerViewChild.moveBar();
    }, 450 );
  }
}
